import React, { useState, useRef, useMemo} from 'react';
import { StyledGridContainer, CreateLeadFooter, StyledSubHeader } from '../../Components/Styled/index';
import { Box, Button, Stack, Typography } from '@mui/material';
import TextFiledWithLabel from '../../Components/TextFieldWithLabel';
import { privateRoutesPath } from '../../Routes';
import { useSnackbar } from 'notistack';
import { createRequestData, getEntityColumns, validateFields } from '../../Utility/apiHelper';
import { useSelector, useDispatch } from 'react-redux';
import { requestShowLoader, requestHideLoader } from '../../Store/Global/action';
import BiztantuLoader from '../../Components/Loader';
import {ACTIVE_STATUS, ADDITIONAL_ATTRIBUTE_FIELDS, handleValidateCodevalue, phoneCountryCodes, searchEntity, STATIC_ENTITY_CONFIG, VENDOR_STATUS} from '../../Utility/constant';
import AddressFields from '../../Components/AddressFields';
import CommonComm from '../../Components/CommonComm';
import CommonPoc from '../../Components/CommonPoc';
import SelectBoxWithLabel from '../../Components/SelectBoxWithLable';
import { EntityNote } from '../../Components/EntityNote';
import NavigationBackButton from '../../Components/NavigationBackButton';
import { formatAdditionalAttributesForPayload } from '../../Utility/payloadFormatter';
import CustomizableFields from '../../Components/CustomizableFields';
import useNavigation from '../../Utility/hooks/useNavigation';

const CreateVendor = ({ }) => {
    const [vendorDetail, setVendorDetail] = useState({
        ...phoneCountryCodes,
        status : "VENDOR_STATUS_ACTIVE"
    })
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isRequired, setRequiredValue] = useState(false);
    const inputRef = useRef(null);
    const dispatch = useDispatch();
    const handleChangeVendorData = (event) => {
        setVendorDetail({
            ...vendorDetail,
            [event.target.name]: event.target.value
        })
    }
    
    const { navigateTo } = useNavigation();
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData); 
    const isloadingprogress = useSelector(state => state.global.isLoading);
    const vendorStatusData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == VENDOR_STATUS)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);
    const allEntityData = useSelector((state) => state?.customization?.allEntityData || []);
    const vendorTextfieldsData = useMemo(() => {
        const data = getEntityColumns(allEntityData, "VENDOR");
        const {id,status ,...rest} = Object.keys(data).length > 0 ?  data : STATIC_ENTITY_CONFIG?.VENDOR;
    
            return rest
    }, [allEntityData]);
    const handleSaveVendor = async() => {
        const reqUrl = `${process.env.REACT_APP_BASE_URL}vendors`
        const {errors,hasError} = validateFields(vendorTextfieldsData, vendorDetail);
            if (hasError) {
                setRequiredValue(errors);
                    enqueueSnackbar(
                        handleValidateCodevalue(internationalise, "COMMON_MSG_MANDATORY_FIELDS"),
                    { variant: "error" }
                );
            return;
        } else {
            const reqPayload = formatAdditionalAttributesForPayload(
                            {
                              ...vendorDetail,
                              registeredAddress : vendorDetail?.address
                            },
                            ADDITIONAL_ATTRIBUTE_FIELDS
                        );
            
            dispatch(requestShowLoader())
            const responseData = await createRequestData(reqPayload,reqUrl);
            if(responseData?.status == 200) {
                
                enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_CREATED_SUCCESSFULLY"), { variant: 'success' });
                dispatch(requestHideLoader())
                navigateTo(`${privateRoutesPath.EDIT_MERCHANT}/${responseData?.data?.id}`,{},searchEntity?.vendor);
            }
             else {
                dispatch(requestHideLoader())
                if (responseData?.propererror?.status !== 401) {
                    enqueueSnackbar(handleValidateCodevalue(internationalise,responseData?.propererror?.data?.message || "COMMON_PLEASE_TRY_AGAIN"), { variant: 'error' });
                }
            }
        }
        
    }

    return (
        <BiztantuLoader open={isloadingprogress} isChildren={true}>
             <Box className='globalBox'>
                <StyledSubHeader>
                                 {handleValidateCodevalue(internationalise,'VEND_EDIT_VENDOR_DETAILS')}
                </StyledSubHeader>
                <StyledGridContainer>
                    <TextFiledWithLabel
                        name="name"
                        inputRef={inputRef}
                        error = {vendorDetail?.name? false : isRequired?.name}
                        required = {true}
                        label={handleValidateCodevalue(internationalise,'VEND_EDIT_NAME')}
                        handleOnChange={handleChangeVendorData}
                        value={vendorDetail?.name}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    
                    <SelectBoxWithLabel
                        ownerdropdown = {false}
                        disabled = {true}
                        name= "status"
                        value= {vendorDetail?.status || ""}
                        error = {vendorDetail?.status? false : isRequired?.status}
                        isStatic={false}
                        optionMenuItem={vendorStatusData}
                        label={handleValidateCodevalue(internationalise,'VEND_EDIT_STATUS')}
                        handleOnChange={handleChangeVendorData}
                    />
                </StyledGridContainer>

            <CustomizableFields
                CUSTOMIZABLE_FIELDS={ADDITIONAL_ATTRIBUTE_FIELDS}
                entity = "VENDOR"
                config={vendorTextfieldsData}
                values={vendorDetail}
                setValues={setVendorDetail}
                handleOnChange={handleChangeVendorData}
                errors={isRequired}
                />
               <CommonComm
                required={true}
                requiredValue = {isRequired}
                isDetailPage = {true}
                handleOnChange={handleChangeVendorData}
                state = {vendorDetail}
               />
               
                    <AddressFields
                    setEntityDetails={setVendorDetail}
                    isViewMode = {false}
                    onChange={handleChangeVendorData}
                    entityDetails={vendorDetail}
                    /> 
                <CommonPoc
                isDetailPage={true}
                requiredValue={false}
                handleOnChange={handleChangeVendorData}
                state={vendorDetail}
                />

                    <EntityNote
                    entityDetails = {vendorDetail} 
                    onChange = {handleChangeVendorData}
                    headingLabel = {handleValidateCodevalue(internationalise,"COMMON_SPECIAL_NOTE")}
                  />
            </Box>
            <CreateLeadFooter>
                <Stack alignItems="center" display={"flex"} justifyContent={"space-between"} flexDirection={"row"}>
               
                <Typography variant='h6'>
                        {handleValidateCodevalue(internationalise,'VEND_EDIT_TITLE_CREATE')}
                </Typography>
           
                <NavigationBackButton 
                    targetTab="VENDOR_SIDEBAR_MENU"
                    additionalState={{ preserveSearch: true }}
                />
                <Button className='edit-primary' variant="outlined" onClick={handleSaveVendor}>{handleValidateCodevalue(internationalise,'COMMON_SAVE')}
                </Button>
                </Stack>
            </CreateLeadFooter>

        </BiztantuLoader>

    )
}

export default CreateVendor;